<template>
  <div style="overflow:auto;margin-bottom:20px">
    <div class="root-chart" :style="[{'margin-bottom': '0px'}, {'table-layout': treeType === 'physical' && selectedNode.type !== 'root' ? 'fixed' : 'auto'}]">
      <!-- <ul>
        <li v-for="objDefine in objDefineList" :style="{ width: objDefine.calcWidth + '%' }" :class="{ active: objDefine.isActive }" :key="objDefine.objDefineId" @click="changeActivePage(objDefine)">
          <span>{{objDefine.objDefineName}}</span>
          <span class="status">{{objDefine.count}}대</span>
        </li>
      </ul> -->
      <ul>
        <el-tooltip v-for="objDefine in objDefineList" :key="objDefine.objDefineId"  placement="top">
          <div slot="content">{{objDefine.objDefineName}} {{objDefine.count}}대</div>
          <li :style="getStyleObject(objDefine)" :class="{ active: objDefine.isActive }" :key="objDefine.objDefineId" @click="changeActivePage(objDefine)">
            <span style="overflow:hidden;text-overflow:ellipsis">{{objDefine.objDefineName}}</span>
            <span class="status">{{objDefine.count}}대</span>
          </li>
        </el-tooltip>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEqual, clone } from 'lodash';
import { OBJDEFINE } from '@/constants/objdefine';
import configApi from '@/api/config/common';

export default {
  name: 'WObjtypeBar',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
    isPhysicalManagetypeNode: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      objDefineList: [],
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler(to, from) {
        if (!isNil(from)) {
          if (!isEqual(to.managetypeId, from.managetypeId)) {
            this.$store.dispatch('setObjDefineIdsForPhysical', []);
          }
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  beforeDestroy() {
    this.$store.dispatch('setObjDefineIdsForPhysical', []);
  },
  methods: {
    loadData() {
      if (this.active) {
        const params = {
          treeType: this.treeType,
        };
        if (isEqual(this.treeType, 'physical')) {
          if (this.isPhysicalManagetypeNode) {
            params.managetypeId = this.selectedNode.managetypeId;
          }
        } else {
          params.managegroupIds = this.selectedNode.childManagegroupIds;
        }
        configApi.getObjCountForObjdefine(params).then((response) => {
          if (response.data.success) {
            const tempList = response.data.data;
            if (!this.isPhysicalManagetypeNode) {
              tempList.forEach((items) => {
                if (!isNil(this.selectedObjDefineIds) && this.selectedObjDefineIds.indexOf(items.objDefineId) > -1) {
                  items.isActive = true;
                } else {
                  items.isActive = false;
                }
              });
            } else {
              tempList.forEach((items) => {
                if (!isNil(this.selectedObjDefineIdsForPhysical) && this.selectedObjDefineIdsForPhysical.indexOf(items.objDefineId) > -1) {
                  items.isActive = true;
                } else {
                  items.isActive = false;
                }
              });
            }
            this.objDefineList = tempList;
          }
        });
      }
    },
    /**
     * 해당 objDefineId에 대한 Name을 반환
     * @author kimjy
     * @param  {String} objDefineId
     * @return {String} objDefineName
     */
    getObjDefineName(objDefineId) {
      return OBJDEFINE[objDefineId];
    },
    /**
     * 상단 장비목록의 선택 장비가 변경될 경우
     * @author kimjy
     * @param  {Object} objDefine 선택/해제된 장비의 정보
     */
    changeActivePage(objDefine) {
      objDefine.isActive = !objDefine.isActive;
      if (this.isPhysicalManagetypeNode) {
        const tempSelectedList = clone(this.selectedObjDefineIdsForPhysical);
        if (objDefine.isActive) {
          tempSelectedList.push(objDefine.objDefineId);
        } else {
          tempSelectedList.splice(tempSelectedList.indexOf(objDefine.objDefineId), 1);
        }
        this.$store.dispatch('setObjDefineIdsForPhysical', tempSelectedList);
      } else {
        const tempSelectedList = clone(this.selectedObjDefineIds);
        if (objDefine.isActive) {
          tempSelectedList.push(objDefine.objDefineId);
        } else {
          tempSelectedList.splice(tempSelectedList.indexOf(objDefine.objDefineId), 1);
        }
        this.$store.dispatch('setObjDefineIds', tempSelectedList);
      }
    },
    getStyleObject(objDefine) {
      const treeType = this.treeType;
      if (treeType === 'physical' && this.selectedNode.type !== 'root') {
        return {
          // width: `${1 / this.objDefineList.length}%`,
          'min-width': '100px',
        };
      }
      return {
        width: `${objDefine.calcWidth}%`,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/components/ObjtypeBar.vue